import isFunction from 'lodash/isFunction';
import find from 'lodash/find';
import forEach from 'lodash/forEach';

import './glassSelector.scss';

class GlassSelectorCtrl {
    constructor(imagesService, dataService, sashesService, glassRulesService, ornamentGlassRuleService) {
        this.imagesService = imagesService;
        this.dataService = dataService;
        this.sashesService = sashesService;
        this.glassesOptions = this.dataService.getGlassessOptions();
        this.glassRulesService = glassRulesService;
        this.ornamentGlassRuleService = ornamentGlassRuleService;
    }

    getImageUrl(imgSrc) {
        return this.imagesService.getFullUrl(imgSrc);
    }

    setImage($event, imgSrc) {
        $($event.target).parent().find('.confGlass__ornament-item-icon-hover').attr('src', this.getImageUrl(imgSrc));
    }

    onInit() {
        forEach(this.glassesOptions, (el, index) => {
            this.setSelectedGlass(index, el.selectedGlass, false);
        });

        this.setSelectedOrnament(this.selectedOptionId, false);
        this.moreInfo = this.dataService.getMoreInfo('glass');
        //this.fancyboxInitialize();
        this.showOrnamentGlassRuleNotice();
    }

    fancyboxInitialize() {
        $('.confGlass__ornament-item-icon-fancybox').fancybox();
    }

    getOrnament() {
        return this.selectedOptionId;
    }

    getSelectedGlass(key) {
        if (key === 0) {
            return this.dataService.getSelectedOptionId('insideGlass');
        }
        return this.dataService.getSelectedOptionId('outsideGlass');
    }

    openModal(moreInfo) {
        if (isFunction(this.openModalCallback)) {
            this.openModalCallback({
                modalTitle: moreInfo.attributes.name,
                modalContent: moreInfo.attributes.content,
            });
        }
    }

    isRoofWindow() {
        return this.dataService.getProductType() === 'roof_window'
    }

    reset() {
        this.selectedOptionId = 1;
        this.dataService.resetGlazing();
    }

    setSelectedOrnament(id, refreshPrice = true) {
        this.selectedOptionId = id;
        this.dataService.updateSelectedOptions('ornament', id, 'ornament', refreshPrice);
    }

    setSelectedGlass(key, id, refreshPrice = true) {
        const insideGlass = 0;

        if (key === insideGlass) {
            this.dataService.updateSelectedOptions('insideGlass', id, 'glass', refreshPrice);
        } else {
            this.dataService.updateSelectedOptions('outsideGlass', id, 'glass', refreshPrice);
        }
        this.glassesOptions[key].selectedGlass = id;
        this.dataService.checkDuplexMullionAvailability();
    }

    closeBox() {
        if (isFunction(this.closeBoxCallback)) {
            this.closeBoxCallback();
        }
    }

    hideGlassOption(glazingKey, glassData) {
        if (this.dataService.isProductEligibleForGlazingRule()) {
            if (glazingKey === 0) {
                return this.glassRulesService.hideInsideGlass(
                    glassData,
                    this.dataService.getSelectedOption('outsideGlass', 'glass')
                );
            }

            return this.glassRulesService.hideOutsideGlass(
                glassData,
                this.dataService.getSelectedOption('insideGlass', 'glass')
            );
        }
    }

    disableOrnamentOption() {
        let selectedInsideGlass = this.dataService.getSelectedOption('insideGlass', 'glass');

        return this.dataService.isProductEligibleForOrnamentGlassRule() &&
            this.ornamentGlassRuleService.checkIfLaminatedOrSafetyGlassOnInside(selectedInsideGlass);
    }

    disableGlassOption(glassOption, glazingKey) {
        if (glazingKey === 0) {
            let selectedOrnament = this.dataService.getSelectedOption('ornament', 'ornament');

            return this.dataService.isProductEligibleForOrnamentGlassRule() &&
                this.ornamentGlassRuleService.checkIfLaminatedOrSafetyGlassOnInside(glassOption) &&
                this.ornamentGlassRuleService.checkIfOrnamentOnInside(selectedOrnament);
        }
    }

    showOrnamentGlassRuleNotice() {
        let selectedInsideGlass = this.dataService.getSelectedOption('insideGlass', 'glass');
        let selectedOrnament = this.dataService.getSelectedOption('ornament', 'ornament');

        return this.dataService.isProductEligibleForOrnamentGlassRule() &&
            (
                this.ornamentGlassRuleService.checkIfLaminatedOrSafetyGlassOnInside(selectedInsideGlass) ||
                this.ornamentGlassRuleService.checkIfOrnamentOnInside(selectedOrnament)
            );
    }

    showGlazingRuleNotice() {
        return this.dataService.isProductEligibleForGlazingRule() &&
            this.glassRulesService.areConditionsMet(
                this.dataService.getSelectedOption('insideGlass', 'glass'),
                this.dataService.getSelectedOption('outsideGlass', 'glass')
            );
    }
}

GlassSelectorCtrl.$inject = ['imagesService', 'dataService', 'sashesService', 'glassRulesService', 'ornamentGlassRuleService'];

export default GlassSelectorCtrl;